import { render, staticRenderFns } from "./tabDestinationDelivery.vue?vue&type=template&id=354d1423&scoped=true&"
import script from "./tabDestinationDelivery.vue?vue&type=script&lang=js&"
export * from "./tabDestinationDelivery.vue?vue&type=script&lang=js&"
import style0 from "./tabDestinationDelivery.vue?vue&type=style&index=0&id=354d1423&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354d1423",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('354d1423')) {
      api.createRecord('354d1423', component.options)
    } else {
      api.reload('354d1423', component.options)
    }
    module.hot.accept("./tabDestinationDelivery.vue?vue&type=template&id=354d1423&scoped=true&", function () {
      api.rerender('354d1423', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/components/booking/tabs/tabDestinationDelivery.vue"
export default component.exports